export default "__VITE_ASSET__CjoXUoZ6__"